import { Tooltip } from '@/components/tooltips';
import { TranslationKeys } from '@/localization';
import { toRuntimeTranslationKey } from '@/localization/translationKey';
import { Listbox } from '@headlessui/react';
import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import HelpIcon from '../../../../assets/icons/help-icon.svg?react';

type SelectLabelProps = {
  label: TranslationKeys;
  required?: boolean;
  tooltip?: string;
};

const SelectLabelComp: FC<SelectLabelProps> = ({ label, required = false, tooltip }) => {
  const { t } = useTranslation();
  const labelKey = toRuntimeTranslationKey(label);

  return (
    <Listbox.Label className='flex items-center gap-0.5 text-sm font-medium text-secondary-700'>
      <p className='first-letter:capitalize'>{t(labelKey as any)}</p>
      {required ? <p className='text-brand-600'>*</p> : null}
      {tooltip ? (
        <Tooltip tooltipContent={tooltip}>
          <HelpIcon className='size-4 text-quaternary-400' />
        </Tooltip>
      ) : null}
    </Listbox.Label>
  );
};

export const SelectLabel = memo(SelectLabelComp);
